import React, { useEffect, useState } from "react";
import style from "css/landing.module.css";

function Slogan(props) {
  // useEffect(() => {
  //   if (props.ref.current) {
  //     console.log("slogan 영역 : ", props.ref);
  //   }
  // }, [props.ref]);

  return (
    <div className={style.slogan_wrap} ref={props.ref}>
      <div className={style.slogan_outer}>
        <div className={style.slogan_inner} style={{ color: props.textColor }}>
          <div className={style.slogan_title}>Tomorrow Starts Here !</div>

          <div className={style.slogan_text}>
            <span>
              변화의 물결속에서
              <br />
              혁신을 일으킬
            </span>
            <div className={style.slogan_company_name}>Riv Technology !</div>
          </div>

          <button
            className={style.slogan_skip_btn}
            onClick={() => props.skip()}
            style={{ color: props.textColor, borderColor: props.textColor }}
          >
            Skip
          </button>
        </div>

        <div
          id="slogan_box"
          className={style.slogan_box}
          style={{
            transform: `scale(${props.boxStyle?.scale ?? 0})`,
            opacity: props.boxStyle?.opacity ?? 0,
            transition: "transform 0.2s, opacity 0.2s",
          }}
        />
      </div>
    </div>
  );
}

export default Slogan;
